import {
    createStyles,
    WithStyles,
    withStyles,
    WithTheme,
} from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";
import { CheckIcon } from "../../assets/icons";

const styles = (theme: RelodeTheme) => {
    const secondaryColor = theme.palette.secondary;
    return createStyles({
        root: {
            borderStyle: "solid",
            borderColor: secondaryColor.dark,
            borderWidth: 1,
            backgroundColor: secondaryColor.light,
            display: "grid",
            gridTemplateAreas: `
                'icon content'
            `,
            gridTemplateColumns: "40px auto",
            gridTemplateRows: "auto",
            gridColumnGap: theme.spacing(3),
            flexDirection: "row",
            padding: theme.spacing(3),
            margin: theme.spacing(2, 0, 2, 0),
        },
        small: {
            padding: theme.spacing(1),
            gridColumnGap: theme.spacing(1),
        },
        icon: {
            color: secondaryColor.contrastText,
            width: 40,
            height: 40,
            gridArea: "icon",
            alignSelf: "center",
            justifySelf: "stretch",

            "& path": {
                fill: secondaryColor.contrastText,
            },
        },
        content: {
            textAlign: "center",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            gridArea: "content",
            alignSelf: "center",
            justifySelf: "stretch",
            color: secondaryColor.contrastText,
        },
        contentWithIcon: {
            marginLeft: theme.spacing(2),
        },
        contentComponent: {
            textAlign: "inherit",
            marginLeft: 0,
        },
    });
};

interface Props extends WithStyles<typeof styles>, WithTheme {
    text?: string;
    showIcon?: boolean;
    children?: any;
    small?: boolean;
    className?: string;
    delay?: number;
    callback?: () => void;
}

interface State {
    visible: boolean;
}

export const FormSuccessBox = withStyles(styles, {
    name: "FormSuccessBox",
    withTheme: true,
})(
    class extends React.Component<Props, State> {
        _timer;
        constructor(props: Props) {
            super(props);
            this.state = {
                visible: true,
            };
        }

        componentDidMount() {
            this.setTimer();
        }

        componentWillUnmount() {
            clearTimeout(this._timer);
        }

        setTimer() {
            // clear any existing timer
            if (this._timer != null) {
                clearTimeout(this._timer);
            }
            const { delay, callback } = this.props;
            if (delay) {
                // hide after `delay` milliseconds
                this._timer = setTimeout(() => {
                    if (this.state.visible) this.setState({ visible: false });
                    if (!!callback) callback();
                    this._timer = null;
                }, delay);
            }
        }

        render() {
            const {
                classes,
                children,
                text,
                showIcon = false,
                small,
                className: classNameProp,
            } = this.props;

            const rootClasses = classnames(classes.root, {
                [classes.small]: small,
            });

            const contentClasses = classnames(
                classes.content,
                {
                    [classes.contentComponent]: !text,
                    [classes.contentWithIcon]: showIcon,
                },
                classNameProp
            );

            const renderContent = () =>
                !!text ? (
                    <span className={contentClasses}>{text}</span>
                ) : (
                    <div className={contentClasses}>{children}</div>
                );

            return this.state.visible ? (
                <div className={rootClasses}>
                    {showIcon && <CheckIcon className={classes.icon} />}
                    {renderContent()}
                </div>
            ) : null;
        }
    }
);
